export const DEFAULT_COLOR = '#0096d6'
